import type { TypographyOptions } from '@mui/material/styles/createTypography';

import { getFontPairing, type FontPairing } from '../fonts';

export const createTypography = (fonts?: FontPairing): TypographyOptions => {
  const { heading: heroSerif, body } = fonts ?? getFontPairing();

  return {
    fontFamily: body,
    body1: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.5
    },
    body2: {
      fontSize: '0.8125rem',
      fontWeight: 400,
      lineHeight: 1.54
    },
    button: {
      fontWeight: 600
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.5
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.5
    },
    subtitle2: {
      fontSize: '0.8125rem',
      fontWeight: 500,
      lineHeight: 1.54
    },
    overline: {
      fontSize: '0.75rem',
      fontWeight: 600,
      letterSpacing: '0.5px',
      lineHeight: 2.5,
      textTransform: 'uppercase'
    },
    h1: {
      fontFamily: heroSerif,
      fontWeight: 400,
      fontSize: '3.25rem',
      lineHeight: 1.1,
      letterSpacing: '-0.01em'
    },
    h2: {
      fontFamily: heroSerif,
      fontWeight: 400,
      fontSize: '2.75rem',
      lineHeight: 1.12,
      letterSpacing: '-0.01em'
    },
    h3: {
      fontFamily: heroSerif,
      fontWeight: 400,
      fontSize: '2.25rem',
      lineHeight: 1.15,
      letterSpacing: '-0.005em'
    },
    h4: {
      fontFamily: heroSerif,
      fontWeight: 400,
      fontSize: '1.875rem',
      lineHeight: 1.2,
      letterSpacing: '-0.005em'
    },
    h5: {
      fontFamily: heroSerif,
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: 1.25,
      letterSpacing: '0em'
    },
    h6: {
      fontFamily: heroSerif,
      fontWeight: 400,
      fontSize: '1.25rem',
      lineHeight: 1.3,
      letterSpacing: '0em'
    }
  };
};
